// extracted by mini-css-extract-plugin
export default {"samples":"DocumentThumbnail_samples__KJgHU","imageContainer":"DocumentThumbnail_imageContainer__biyZR","overlay":"DocumentThumbnail_overlay__2hDR5"};